import React, { useState } from "react";

const AboutLong = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section className="section bg-cream-200/60">
      <div className="max-w-4xl mx-auto px-5 lg:px-10">
        <h2 className="font-serif text-navy-700 text-4xl md:text-5xl text-center leading-tight">
          What is <span className="italic">GALERIECOP?</span>
        </h2>

        <div className={`mt-8 space-y-5 text-navy-700/80 leading-relaxed text-[16px] ${expanded ? "" : "max-h-[260px] overflow-hidden relative"}`}>
          <p>
            GALERIECOP is a private QR code photo-sharing platform designed to make collecting photos, videos and guestbook messages from events simple and organized. Instead of chasing images across chat apps, emails or text messages, guests can upload everything directly to a single private gallery using a QR code or private link.
          </p>
          <p>
            A GALERIECOP gallery comes with flexible customizations so you can tailor the photo-sharing experience to suit your event. Adjust privacy settings, enable or disable guest uploads and control how content is shared. Whether you prefer a single gallery or multiple albums, GALERIECOP keeps everything neatly organized.
          </p>
          <p>
            For event hosts, QR photography is a game-changer. It provides a simple yet effective way to organize and distribute photos to the right people. Whether you&apos;re managing a private gallery or running a large-scale event, GALERIECOP makes the photo collection process easy with a super simple guest experience.
          </p>
          <p>
            With digital galleries, smart-sharing solutions and our unique private social network, capturing and preserving event memories has never been easier. Come and see why GALERIECOP is the #1 global platform for event photo collection trusted by 150K+ events.
          </p>
          {!expanded && (
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-cream-200/90 to-transparent" />
          )}
        </div>
        <div className="text-center mt-6">
          <button onClick={() => setExpanded(!expanded)} className="text-coral-300 font-semibold hover:text-coral-400 transition-colors">
            {expanded ? "Read Less" : "Read More"}
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutLong;
